const PostAffTracker = (<any>window).PostAffTracker || null;

interface postAffiliateParams {
  discount: any;
  price: any;
  transactionId: String;
  promotionCode: String;
};

const postAffiliate = ({
  discount,
  price,
  transactionId,
  promotionCode
} : postAffiliateParams ) => {
  if (!PostAffTracker) return;
  PostAffTracker.setAccountId('default1');
  const sale = PostAffTracker.createSale();
  sale.setTotalCost(discount['discount'] ? discount?.amount : price.price);
  sale.setOrderID(transactionId);
  sale.setCoupon(promotionCode);
  sale.setProductID(price.id);
  PostAffTracker.register();
}

export { postAffiliate };
